module.exports = __webpack_public_path__ + "img/board-icon.9ec94d8a.svg";